import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver, EventEmitter,
  Input,
  OnDestroy,
  OnInit, Output,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {select, Store} from '@ngrx/store';
import {getUserInfo, hasFeature} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {UserInfo} from '@shared/models/user-info.model';

@Component({
    standalone: false,
    selector: 'particle-task-body',
  templateUrl: './task-body.component.html',
  styleUrls: ['./task-body.component.scss']
})
export class TaskBodyComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('dynamicComponent', {read: ViewContainerRef}) viewContainerRef;
  @Input() data: any;

  componentView: any;
  currentlyOpenedEditor: string;

  selectedMainViewDetails: any;
  @Input() defaultMainViewDetails: any;
  @Input() selectedMainViewDetails$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  @Input() taskMenuItemsMapper: any = {};
  @Output() actionEvent$: EventEmitter<any> = new EventEmitter();

  unSubscribe$ = new Subject<void>();
  hasFeature$: Observable<any>;
  isInformationBarClose = false;
  isDefaultMainView = true;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private securityStore: Store<SecurityState>,
              private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.securityStore.pipe(select(getUserInfo)).subscribe(user => {
      this.validateStackHolderMessage(user);
    });
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
  }

  changeView(selectedMainView) {
    this.selectedMainViewDetails = selectedMainView;
    if (!this.selectedMainViewDetails) {
      this.selectedMainViewDetails = JSON.parse(JSON.stringify(this.defaultMainViewDetails));
    }
    this.isDefaultMainView = this.selectedMainViewDetails.id === this.defaultMainViewDetails.id;
    this.renderMainViewChanges(this.selectedMainViewDetails);
  }

  renderMainViewChanges($event: any) {
    if (!$event.editor) {
      return;
    }
   // this.changeDetectorRef.detectChanges();
    this.currentlyOpenedEditor = $event.editor;
    const resolvedComponent = <Type<any>>RootDynamicComponentHelper.getComponent($event.editor);
    this.viewContainerRef.clear();
    const component = this.viewContainerRef.createComponent(resolvedComponent);
    component.instance.data = this.data;
    component.instance.dynamicData = this.data.input;
    component.instance.taskMenuItemsMapper = this.taskMenuItemsMapper;
    this.componentView = component.instance;
    if (this.componentView.actionEvent$) {
      this.componentView.actionEvent$.subscribe(action => {
        if (action) {
          this.handleActionEvent(action);
        }
      });
    }
  }

  resetDefaultMainView() {
    //this.selectedMainViewDetails = JSON.parse(JSON.stringify(this.defaultMainViewDetails));
    //this.renderMainViewChanges(this.selectedMainViewDetails);
    this.actionEvent$.emit({id: 'defaultBodyView', type: 'MainViewBodyChangeEvent', card: this.data.input.card});
  }

  onCloseClicked() {
    if (this.componentView.onCancelClicked) {
      const result = this.componentView.onCancelClicked();
      console.log('onCancelClicked' + result);
      if (result instanceof Subject || result instanceof Observable) {
        result.pipe(take(1)).subscribe(res => {
          if (res !== false) {
            this.resetDefaultMainView();
          }
        });
      } else {
        if (result !== false) {
          this.resetDefaultMainView();
        }
      }
    } else {
      this.resetDefaultMainView();
    }
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private handleActionEvent($event: {id: string, type: string, card: any, params?: any}) { // value contains card
    switch ($event.type) {
      default:
        this.actionEvent$.emit($event);
        break;
    }
  }

  close() {
    this.isInformationBarClose = true;
  }

  ngAfterViewInit(): void {
    this.selectedMainViewDetails$.pipe(takeUntil(this.unSubscribe$)).subscribe(selectedMainView => {
      this.changeView(selectedMainView);
    });
  }

  private validateStackHolderMessage(user: UserInfo) {
    if (this.data && this.data.input && this.data.input.card) {
      const taskCreatedBy = this.data.input.card.createdBy;
      if (user.email.toLowerCase() === taskCreatedBy.email.toLowerCase()) {
        this.isInformationBarClose = true;
      }
    }
  }
}
